(() => {
  const bindOnce = (el, key) => {
    if (!el || el.dataset[key] === 'true') return false;
    el.dataset[key] = 'true';
    return true;
  };

  const initAccordion = (root) => {
    const wrap = root.matches?.('[data-minus-about-faq]') ? root : root.querySelector('[data-minus-about-faq]');
    if (!wrap || !bindOnce(wrap, 'minusAboutFaqBound')) return;

    wrap.querySelectorAll('[data-accordion-toggle]').forEach((button) => {
      button.addEventListener('click', () => {
        const item = button.closest('.accordion-item');
        if (!item) return;
        const open = item.classList.contains('active');
        wrap.querySelectorAll('.accordion-item').forEach((el) => {
          el.classList.remove('active');
          const header = el.querySelector('[data-accordion-toggle]');
          if (header) header.setAttribute('aria-expanded', 'false');
        });
        if (!open) {
          item.classList.add('active');
          button.setAttribute('aria-expanded', 'true');
        }
      });
    });
  };

  const initAll = (root = document) => {
    initAccordion(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));

  // Minus Hero Slider
  document.querySelectorAll('[data-minus-hero]').forEach((hero) => {
    const autoplay = hero.dataset.autoplay === 'true';
    const speed = parseInt(hero.dataset.autoplaySpeed, 10) || 5000;
    const dots = hero.querySelectorAll('[data-hero-dot]');

    if (!autoplay || dots.length < 2) return;

    let timer;
    let index = 0;

    const goTo = (i) => {
      index = i;
      dots[index].click(); // reuses your existing slide-change logic
    };

    const start = () => {
      timer = setInterval(() => {
        index = (index + 1) % dots.length;
        goTo(index);
      }, speed);
    };

    const stop = () => clearInterval(timer);

    start();
    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);

    // if user manually clicks a dot, resync index + restart timer
    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        index = i;
        stop();
        start();
      });
    });
  });
})();
